import animateScrollTo from './utils';

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.menu-icon').forEach( element => {
        element.addEventListener('click', function (event) {
            document.getElementById('menu__wrapper').classList.add('active');
            document.getElementById('main-right-container').classList.remove('hide');
        });
    });

    document.getElementById('scroll-to-top-left').addEventListener('click', function (event) {
        window.scrollTo(0,0);
        document.getElementById('main-left-container').scrollTo({
            top: 0,
            behavior: 'smooth'
          });
    });
});